export default {
  layout: {
        zh: '简体中文',
        tc: '繁體中文',
        en: 'English',
        kr: '한국어',
        jp: '日本語',
  },
  footer: {},
  menu: {
      home: '홈',
      mining: '마이닝 기계',
      wallet: '지갑',
      me: '마이 페이지',
      login: '로그인'
  },
  home: {
      buy: '구매',
      dailyEarnings: '당일 수익',
      topUp: '충전하기',
      desc: '제품 파라미터: 숨겨진 성장과 큰 성공을 위해 설계됨',
      popup: {
          buy: '즉시 구매',
          desc: '마이닝 기계 수익: 일일 1% 수익 (일 3U). 수익 획득을 위해 매 30일마다 데이터 캡슐(35U)을 지불해야 하며, 데이터 캡슐 1개 포함',
          totalAmount: '총 금액',
          wallet: '자금 지갑',
          revenue: '수익 지갑',
          pls: '수익 지갑으로 결제',
          config: '지갑 설정',
          most: '최대 사용량',
          confirmPurchase: '구매 확인',
          plsDes: '추천인 입력',
          confirm: '확인',
      }
  },
  mining: {
      title: '내 마이닝 기계 목록',
      day: '당일 총 생산량',
      activate: '활성화 대기 데이터 캡슐(개)',
      miningrig: '보유 마이닝 기계(대)',
      output: '생산 중',
      dataCapsule: '데이터 캡슐',
      time: '구매 시간',
      remaining: '남은 일수(일)',
      today: '오늘 생산량',
      total: '총 생산량',
      expired: '곧 만료',
      stop: '생산 중단',
  },
  record: {
      title: '계정 기록',
      empty: '기록 없음',
      wallet: '자금 지갑',
      time: '날짜',
      remark: '비고: 포인트별 발급',
      complimentary: '비고: 증정',
      static: '비고: 정적 수익',
  },
  wallet: {
      title: '내 지갑',
      record: '자금 기록',
      static: '당일 정적 수익',
      dynamic: '당일 동적 보상',
      topup: '충전',
      withdraw: '출금',
      totalRevenue: '마이닝 기계 총 수익',
      totalReward: '총 보상',
      funds: '자금 지갑',
        fund1: '자금 지갑',
        fund2: '배분 지갑',
        fund3: '배분 지갑',
  },
  withdraw: {
      title: '출금',
      revenue: '수익 지갑',
      amount: '출금 금액',
      confirm: '출금 확인',
      rule: '출금 규칙',
      desc: '출금 수수료: 거래당 5U 또는 5%, 높은 금액 기준',
      desc1: '최소 출금 금액: 10U',
      list: '출금 목록',
      success: '성공',
      time: '날짜',
      error: '실패',
  },
  me: {
      recommend: '내 추천인',
      subscription: '구독 실적',
      directReferral: '직접 추천 실적',
      team: '내 팀(명)',
      performance: '팀 실적',
      serialNumber: '일련 번호',
      level: '등급',
      individual: '개인 실적',
      time: '가입 날짜',
      home: '홈',
      last: '마지막',
  },
};